export class EmptyShowcaseError extends Error {
    constructor(id: string) {
        super(`Empty showcase: ${id}`);
    }
}
